import React from 'react';
import TermsContent from '../components/TermsContent';

const TermsPage: React.FC = () => {
  return (
    <div style={{ maxWidth: 960, margin: '32px auto', padding: '0 16px', fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, sans-serif' }}>
      <h1 style={{ marginBottom: 12 }}>LoConvo Terms</h1>
      <p style={{ color: '#4b5563', marginBottom: 20, lineHeight: 1.55 }}>
        These Terms apply to all access and use of LoConvo, including sign-in via Google or Microsoft. If you do not agree, please do not use the service.
      </p>
      <div
        style={{
          border: '1px solid #e5e7eb',
          borderRadius: 12,
          padding: '12px 16px',
          boxShadow: '0 4px 18px rgba(0,0,0,0.06)',
          background: 'white'
        }}
      >
        <TermsContent />
      </div>
      <p style={{ color: '#4b5563', marginTop: 16, lineHeight: 1.5 }}>
        Questions? Email <a href="mailto:legal@loconvo.com" style={{ color: '#2563eb' }}>legal@loconvo.com</a> or <a href="mailto:support@loconvo.com" style={{ color: '#2563eb' }}>support@loconvo.com</a>.
      </p>
    </div>
  );
};

export default TermsPage;
